module.exports = __webpack_public_path__ + "static/assets/2bc4228a45dc91945c326463dbba5bc8.svg";